














import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IWebhook } from "@/models/webhooks";

@Component
export default class WebhookStatusIcon extends Vue {
  // Props

  @Prop({ required: true })
  public webhook!: IWebhook;

  // Computed

  public get statusIcon() {
    if (this.webhook.enabled)
      return {
        icon: "check-circle",
        label: this.$t("_.enabled"),
        type: "is-success"
      };

    return {
      icon: "pause-circle",
      label: this.$t("_.disabled"),
      type: "is-grey"
    };
  }
}
